import {useEffect, useState} from 'react'
import {Button, Card, Col, Container, Form, Row, Spinner, Table} from 'react-bootstrap'
import ButtonComp from '../../components/Button'
import Select from '../../components/Select'
import {FormikProps, useFormik} from 'formik'
import {ITaskGet, ITaskFilter, IStatus} from '../../interface/task/task'
import {DEFAULT_META, DEFAULT_PAGE_OPTION} from '../../constants/page-option/page-option'
import {IPageMeta} from '../../interface/paging/meta-paging'
import {IPageOption} from '../../interface/paging/paging'
import {GetTaskLogService, GetTaskService, GetTaskStatusService} from '../../service/task.service'
import {ColumnDef} from '@tanstack/react-table'
import {KTIcon} from '../../../_metronic/helpers'
import {TABLE_ACTION} from '../../constants/enum/table-action'
import TableData from '../../components/Table'
import {useUserDispatch, useUserSelector} from '../../store/user'
import {useCommonSelector, useCommonDispatch} from '../../store/common'
import {IPlant} from '../../interface/plant/plant'
import Multiselect from '../../components/MultiSelect'
import {GetPlantService} from '../../service/plant.service/plant.service'
import {GetCompanybyCompanyGroupIdService} from '../../service/company.service'
import {ICompany} from '../../interface/company/company'
import dayjs from 'dayjs'
import {formatDate} from '../../helpers'
import {useNavigate} from 'react-router-dom'
import TextField from '../../components/TextField'
import ModalLog from '../../components/ModalLog'
import {useSearchParams} from 'react-router-dom'

const initialValues: ITaskFilter = {
  companyIds: [],
  plantIds: [],
  status: undefined,
  darTaskNumber: undefined,
}
const TaskPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()

  const {user, isSuperAdmin, isUser, myCompany} = useUserSelector()
  const {query} = useCommonSelector()
  const {setCommonQuery} = useCommonDispatch()

  const navigate = useNavigate()

  const [columns, setColumns] = useState<ColumnDef<ITaskGet>[]>([])
  const [tasks, setTasks] = useState<ITaskGet[]>()
  const [status, setStatus] = useState<IStatus[]>()
  const [meta, setMeta] = useState<IPageMeta>(DEFAULT_META)
  const [pageOption, setPageOption] = useState<IPageOption>(DEFAULT_PAGE_OPTION)
  const [plants, setPlants] = useState<IPlant[]>([])
  const [plantsAll, setPlantsAll] = useState<IPlant[]>()
  const [companies, setCompanies] = useState<ICompany[]>([])
  const [modalLogShow, setModalLogShow] = useState(false)
  const [logId, setLogId] = useState<string>('')
  const [isStart, setIsStart] = useState<boolean>(false)

  const formikFilter: FormikProps<ITaskFilter> = useFormik({
    initialValues: initialValues,
    onSubmit: async (values, {setSubmitting}) => {
      await handleTask()
      setSubmitting(false)
    },
  })
  useEffect(() => {
    if (!isStart) {
      setIsStart(true)
      return
    }
    formikFilter.submitForm()
  }, [pageOption.page, pageOption.sortBy, pageOption.order, pageOption.limit])

  useEffect(() => {
    getPlants()
    getTaskStatus()

    const _columns: ColumnDef<ITaskGet>[] = [
      {
        header: 'Action',
        id: 'action',
        cell: (info) => (
          <div className='d-flex justify-content-center'>
            <Button
              className='btn btn-icon btn-success btn-sm me-1'
              onClick={() => navigate(`/tasks/assign-tag?id=${info.row.original.id}`)}
            >
              <i className='fs-1 bi bi-arrow-right-short'></i>
            </Button>
            <Button
              className='btn btn-icon btn-primary btn-sm me-1'
              onClick={() => onOpenLog(info.row.original)}
            >
              <i className='fs-6 bi bi-clipboard2-pulse-fill'></i>
            </Button>
          </div>
        ),
      },
      {
        header: 'Task ID',
        accessorFn: (row) => row.taskNo,
        id: 'taskNo',
        cell: (info) => info.getValue(),
      },
      {
        header: 'DAR Task Number',
        accessorFn: (row) => row.darTaskCode,
        id: 'darTaskCode',
        cell: (info) => info.getValue(),
      },
      {
        header: 'DAR Task Study Number',
        accessorFn: (row) => row?.darTaskStudyCode || '-',
        id: 'darTaskStudyCode',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Company',
        accessorFn: (row) => row.company.name || '-',
        id: 'company',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Status',
        accessorFn: (row) => row.status.name,
        id: 'status.name',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Created By',
        accessorFn: (row) => row.createdBy,
        id: 'createdBy',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Created Date',
        accessorFn: (row) => formatDate(row.createdAt || ''),
        id: 'createdAt',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Modified By',
        accessorFn: (row) => row.updatedBy,
        id: 'updatedBy',
        cell: (info) => info.getValue(),
      },
      {
        header: 'Modified Date',
        accessorFn: (row) => formatDate(row.updatedAt || ''),
        id: 'updatedAt',
        cell: (info) => info.getValue(),
      },
    ]

    setColumns(_columns)
  }, [])

  useEffect(() => {
    // if (isUser) {
    //   handleTask()
    // }
    if (!plantsAll || plantsAll?.length === 0 || isUser) return

    let _plants = [] as any
    for (let i in formikFilter.values.companyIds) {
      // @ts-ignore
      const id = formikFilter.values.companyIds[i].id
      let temp = plantsAll?.filter((el: any) => {
        return el.company.id == id
      }) as any
      _plants.push(...temp)
    }
    setPlants([..._plants])
  }, [formikFilter.values.companyIds?.length])

  useEffect(() => {
    if (!user) return
    if (isSuperAdmin) {
      const temp = user?.companies.map((e: any) => {
        return e?.company
      })
      setCompanies(temp)
    } else {
      getCompanyByCompanyGroupId(user?.companyGroup?.id as string)
    }
    if (myCompany) {
      const temp = [
        {
          ...myCompany.company,
          companyGroup: user.companyGroup,
        },
      ]
      formikFilter.setFieldValue('companyIds', [...temp])
    }
  }, [user])

  useEffect(() => {
    if (!plantsAll) return
    if (query) {
      if (query?.companyIds) {
        formikFilter.setFieldValue('companyIds', [...query?.companyIds])
        let _plants = [] as any
        for (let i in query?.companyIds) {
          // @ts-ignore
          const id = query?.companyIds[i].id
          let temp = plantsAll?.filter((el: any) => {
            return el.company.id == id
          }) as any
          _plants.push(...temp)
        }
        setPlants([..._plants])
      }
      if (query?.plantIds) {
        formikFilter.setFieldValue('plantIds', [...query?.plantIds])
      }
      if (query?.darTaskNumber) {
        formikFilter.setFieldValue('darTaskNumber', query?.darTaskNumber)
      }
      if (query?.status) {
        formikFilter.setFieldValue('status', query?.status)
      }
      if (query?.companyIds || query?.plantIds || query?.darTaskNumber || query?.status) {
        handleTask()
      }
    }
  }, [plantsAll])

  const onOpenLog = (value?: any) => {
    setLogId(value.id)
    setModalLogShow(true)
  }

  const getCompanyByCompanyGroupId = async (id: string) => {
    const params = {
      getOnlyActive: true,
    } as IPageOption
    const getCompanyService = new GetCompanybyCompanyGroupIdService()
    const _companies = await getCompanyService.request(params, id)
    setCompanies(_companies.data ? _companies.data : _companies)
  }
  const handleTask = async () => {
    const _task = await getTaskFilter()
    setTasks(_task.data)
    setMeta(_task.meta)
    setCommonQuery({
      companyIds: formikFilter.values.companyIds || '',
      plantIds: formikFilter.values.plantIds || '',
      darTaskNumber: formikFilter.values.darTaskNumber || '',
      isActive: formikFilter.values.status || '',
    })
    // setSearchParams({
    //   companyIds: formikFilter.values.companyIds || '',
    //   plantIds: formikFilter.values.plantIds || '',
    //   darTaskNumber: formikFilter.values.darTaskNumber || '',
    //   isActive: formikFilter.values.status || '',
    // })
  }

  const getTaskFilter = async () => {
    const params = {
      ...pageOption,
    } as IPageOption
    let filter = {
      ...formikFilter.values,
      statusIds:
        formikFilter.values.status && formikFilter.values.status !== 'All'
          ? [formikFilter.values.status]
          : undefined,
    }
    for (let key in filter) {
      if (filter.hasOwnProperty(key) && filter[key] === '') {
        filter[key] = undefined
      }
    }
    const getTaskService = new GetTaskService()
    const _task = await getTaskService.request(params, filter)
    return _task
  }

  const getPlants = async () => {
    const params = {
      getOnlyActive: true,
      getAll: true,
    } as IPageOption
    const getPlantService = new GetPlantService()
    const _plants = await getPlantService.request(params)
    setPlantsAll([..._plants.data.list])
  }

  const getTaskStatus = async () => {
    const getTaskStatus = new GetTaskStatusService()
    const _status = await getTaskStatus.request()
    setStatus(_status)
  }

  const onSearch = () => {
    if (DEFAULT_PAGE_OPTION === pageOption) {
      formikFilter.submitForm()
    } else {
      setPageOption(DEFAULT_PAGE_OPTION)
    }
  }
  const onReset = () => {
    formikFilter.resetForm()
    formikFilter.setFieldValue('darTaskNumber', '')
    formikFilter.setFieldValue('status', '')
    setTasks(undefined)
    setMeta(DEFAULT_META)
    setPageOption(DEFAULT_PAGE_OPTION)
    setSearchParams({})
    if (isUser) {
      if (myCompany) {
        const temp = [
          {
            ...myCompany.company,
            companyGroup: user?.companyGroup,
          },
        ]
        formikFilter.setFieldValue('companyIds', [...temp])
      }
      // formikFilter.submitForm()
    }
  }
  return (
    <>
      <Card>
        <Card.Body>
          <h1 className='mb-5'>{'AIMS-TAG > Task Management'}</h1>
          <Row>
            <Col xs={12} sm={6} md={3}>
              <Multiselect
                isCompany
                formik={formikFilter}
                name='companyIds'
                label='Company'
                option={companies || []}
                disabled={isUser || formikFilter.isSubmitting}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Multiselect
                formik={formikFilter}
                name='plantIds'
                label='Plant'
                option={isUser ? myCompany?.plants || [] : plants || []}
                disabled={formikFilter.isSubmitting}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <TextField
                formik={formikFilter}
                name={'darTaskNumber'}
                label='DAR Task Number'
                disabled={formikFilter.isSubmitting}
                noCheckText={true}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Select
                formik={formikFilter}
                name={'status'}
                label='Status'
                option={status || []}
                keyLabel='name'
                keyValue='id'
                isSearch
                disabled={formikFilter.isSubmitting}
              />
            </Col>
            <Col className='d-flex justify-content-end mb-3'>
              <ButtonComp
                variant='secondary'
                onClick={() => onReset()}
                doing={formikFilter.isSubmitting}
                icon='bi bi-arrow-clockwise'
              >
                Reset
              </ButtonComp>
              <ButtonComp doing={formikFilter.isSubmitting} onClick={onSearch} icon='bi bi-search'>
                Search
              </ButtonComp>
            </Col>
          </Row>
          <Row>
            <TableData
              doing={formikFilter.isSubmitting}
              data={tasks || []}
              columns={columns}
              meta={meta}
              setMeta={setMeta}
              pageOption={pageOption}
              setPageOption={setPageOption}
            ></TableData>
          </Row>
        </Card.Body>
      </Card>
      <ModalLog
        modalLogShow={modalLogShow}
        setModalLogShow={setModalLogShow}
        getLog={GetTaskLogService}
        logId={logId}
      />
    </>
  )
}

export {TaskPage}
